import React, { useEffect, useState } from 'react';
import styles from './styles.module.css';
import { useHistory } from 'react-router-dom';
import { ManualOrderNotificationContent } from 'services/content';
import { useSelector, useDispatch } from 'react-redux';
import infoCircle from 'assets/info-circle-black.svg';
import * as Types from 'helpers/types';
import moment from 'moment';

const ManualOrderNotification = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { orderHistory } = useSelector((state) => state);
  const currentDate = new Date();
  const [manualOrders, setManualOrders] = useState([]);

  useEffect(() => {
    function filterManualOrders() {
      const filteredManualOrders = orderHistory.orders.filter((order) => {
        const orderStatuses = order?.order_statuses.sort(function (a, b) {
          return new Date(b.timestamp) - new Date(a.timestamp);
        });
        return orderStatuses[0]?.code === 'AwaitingPayment';
      });
      setManualOrders(filteredManualOrders);
    }
    window.MANUAL_JOURNEY === 'true' && filterManualOrders();
  }, [orderHistory]);

  const startOrder = async (manualOrder) => {
    dispatch({ type: Types.START_MANUAL_JOURNEY });
    dispatch({ type: Types.BASKET_CLEAR });
    const individualOrder = orderHistory.orders.find((o) => o.order_id === manualOrder.order_id);
    dispatch({ type: Types.SET_SELECTED_MANUAL_ORDER, payload: individualOrder });
    if (orderHistory.orders[0]?.card_detail) {
      const expiryMonth = orderHistory.orders[0]?.card_detail.expiry.slice(0, 2);
      const expiryYear = orderHistory.orders[0]?.card_detail.expiry.slice(2, 4);
      const expiryDate = new Date('20' + expiryYear, expiryMonth);
      if (currentDate < expiryDate) {
        dispatch({ type: Types.SET_MANUAL_PAYMENT, payload: orderHistory.orders[0]?.card_detail });
      }
    }
    history.push('/pharmacy/dashboard/manual-order');
  };

  if (window.MANUAL_JOURNEY !== 'true' || orderHistory?.loading || !manualOrders.length) return null;

  return (
    <div className={styles.manualOrderNotificationContainer}>
      {manualOrders.map((manualOrder) => {
        return (
          <div className={styles.manualOrderNotification} key={manualOrder.order_id}>
            <div className={styles.manualOrderIconContainer}>
              <img src={infoCircle} className={styles.manualOrderIcon} alt="" />
              <div>
                <p className="title-5">{ManualOrderNotificationContent.headerText}</p>
                <p className="body-2">
                  {ManualOrderNotificationContent.bodyText1}
                  <b>{moment(manualOrder.actionable_until).format('Do MMMM')}</b>
                  {ManualOrderNotificationContent.bodyText2}
                </p>
              </div>
            </div>
            <div className={styles.manualOrderButtonContainer}>
              <button
                id="manual-order-button"
                disabled={orderHistory?.loading}
                onClick={() => startOrder(manualOrder)}
                className={`coop-btn coop-btn--primary ${styles.manualOrderButton}`}>
                {ManualOrderNotificationContent.buttonText}
              </button>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default ManualOrderNotification;
